import { Injectable } from '@angular/core';

/**
 * Service is used to save and restore scroll position
 * In New fund modelling is used, to prevent scrolling down
 * after user go back from rounds to groups
 */
@Injectable({
  providedIn: 'root',
})
export class FsScrollPositionService {
  private scrollPosition: number = 0;

  saveScrollPosition(): void {
    this.scrollPosition = window.scrollY;
  }

  restoreScrollPosition(): void {
    // Use setTimeout to ensure the scroll happens after the DOM has been fully rendered
    setTimeout(() => {
      window.scrollTo(0, this.scrollPosition);
      // Clear the saved position after restoration to free up memory
      this.clearScrollPosition();
    }, 0);
  }

  clearScrollPosition(): void {
    this.scrollPosition = 0;
  }
}
